/**
 * @auth 赖传峰
 * @date 2022/4/10
 */

import {
  defineNuxtPlugin,
  useCookie,
  useRequestHeaders,
} from '#imports'
import useShareId from '~/composables/useShareId'
import { StorageKey } from '~/types/enum'

/**
 * 最多存最近3条，避免 cookie 过大，导致服务器 400 Bad Request Request Header Or Cookie T00 Large
 */
const limitPasscodeCookies = () => {
  const getCookieKeyByPrefix = (prefix: string) => {
    const cookie = import.meta.client ? document.cookie : useRequestHeaders(['cookie']).cookie
    if (!cookie) return []

    return cookie
      .split(';')
      .map(el => el.trim().split('=')[0])
      .filter(el => el.startsWith(prefix))
      .slice(0, -3) // 保留最近3个
  }
  [
    ...getCookieKeyByPrefix(StorageKey.SHARE_PASSCODE_TOKEN),
    ...getCookieKeyByPrefix(StorageKey.SHARE_PWD_CODE),
  ].forEach(key => useCookie(key, { maxAge: undefined }).value = null)
}

export default defineNuxtPlugin(async () => {
  const shareId = useShareId()
  return {
    provide: {
      clearPasscodeToken: () => useCookie(
        `${StorageKey.SHARE_PASSCODE_TOKEN}_${shareId.value}`,
        { maxAge: undefined },
      ).value = null,
      setPasscodeToken: (val: string | null) => {
        useCookie(
          `${StorageKey.SHARE_PASSCODE_TOKEN}_${shareId.value}`,
          {
            maxAge: 12 * 60 * 60,
            sameSite: 'lax',
            secure: true,
          },
        ).value = val
        limitPasscodeCookies()
      },
      getPasscodeToken: (val = shareId.value) => {
        limitPasscodeCookies()
        return useCookie(`${StorageKey.SHARE_PASSCODE_TOKEN}_${val}`)
      },
    },
  }
})
